import styled from "styled-components/macro";
import media from "../../constants/MediaQuery";
import Typography from "../../atoms/typography";
import Button from "../../atoms/Button";
import { useState } from "react";
import Modal from "../../atoms/Modal";
import { CareerForm } from "../../molecules/CareerForm";
import Theme from "constants/Theme";
import { motion } from "framer-motion";

const JoinUs = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <JS>
      <motion.div
        initial={{ y: 50, opacity: 0, scale: 0.8 }}
        whileInView={{ y: 0, opacity: 1, scale: 1 }}
        transition={{ duration: 1 }}
        viewport={{ once: true }}
        className="JoinUs__JS--js-con container"
      >
        <Typography.Heading
          className="landing--text-summary"
          color="pending"
          weight="medium"
          level={4}
          uppercase
          fontType="Galano"
        >
          Want to join us?
        </Typography.Heading>
        <Typography.Heading
          style={{
            fontSize: Theme.fontSizes.xextralarge,
          }}
          uppercase
          color="darkBlue"
          fontType="Galano"
          weight="medium"
          level={1}
          className="landing__heading"
        >
          Our careers
        </Typography.Heading>
        <Typography.Text level="large" weight="medium" fontType="Galano">
          Join our team of amazing talent, check out the open roles we have
        </Typography.Text>
        <Button
          className="icon-free-btn"
          secondary
          text="Submit Resume"
          onClick={() => setIsOpen(true)}
        >
          Submit Resume
        </Button>
      </motion.div>
      <Modal
        width="max-content"
        height="max-content"
        showModal={isOpen}
        onBackdropClick={() => setIsOpen(!isOpen)}
        onCloseClick={() => setIsOpen(!isOpen)}
        maxModal
      >
        <CareerForm />
      </Modal>
    </JS>
  );
};
const JS = styled.div`
  padding: 100px 0;

  .JoinUs__JS {
    &--js-con {
      width: 100%;
      display: flex;
      text-align: center;
      flex-direction: column;
      align-items: center;
      ${media.smallDesktopMin`
       justify-content: center;
       align-items: center;
      `}
    }
  }
`;
export default JoinUs;
